"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mui_1 = require("tss-react/mui");
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const Avatar_1 = __importDefault(require("@mui/material/Avatar"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const styles_1 = require("./styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const CreateNewRecurringDialog = ({ showNewRecurrenceProgress, uiState, txForm, }) => {
    const { classes } = useStyles();
    return (<Dialog_1.default open={Boolean(showNewRecurrenceProgress && uiState.newScheduledTransactionClientId)}>
      <DialogContent_1.default className={classes.dialogContent}>
        <Typography_1.default variant="h5">
          Creating New Recurring
        </Typography_1.default>
        <Paper_1.default className={classes.paper}>
          <Avatar_1.default sx={{ m: 2.5 }}>
            {txForm.payee ? txForm.payee[0].toUpperCase() : '*'}
          </Avatar_1.default>
          <Typography_1.default variant="h6">
            {txForm.payee}
          </Typography_1.default>
        </Paper_1.default>
        <CircularProgress_1.default />
      </DialogContent_1.default>
    </Dialog_1.default>);
};
exports.default = CreateNewRecurringDialog;
